import { render } from "./IfControlSection.vue?vue&type=template&id=425e8c24"
import script from "./IfControlSection.vue?vue&type=script&lang=js"
export * from "./IfControlSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__